export const generateTimestamp = (customDate?: Date): string => {
  const date = customDate || new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() < 10 ? '0' : '') + date.getMonth();
  const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
  const hour = (date.getHours() < 10 ? '0' : '') + date.getHours();
  const minute = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  const second = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
  const milliseconds = (date.getMilliseconds() < 10 ? '0' : '') + date.getMilliseconds();
  return `${year}${month}${day}${hour}${minute}${second}${milliseconds}`;
};
